import React from 'react'
import logo from '../img/logo.png'
import bn from '../img/bn.png'
import sync from '../img/sync.png'
import share from '../img/share.png'

function Landing(props) {
      const {signIn} = props

    return (
        <div>
            <nav class="bp3-navbar bp3-dark">
                <div>
                    <div class="bp3-navbar-group bp3-align-left">
                       <img src={logo} alt="logo" id="logo" />
                        <h3 id="navbar-h4">Stack-Board</h3>
                  </div>

              <div class="bp3-navbar-group bp3-align-right">
                 <button id="get-started-two" onClick={()=>signIn()}>
                     Get Started
                 </button>
              </div>
           </div>
            </nav>

            <div id="banner">
                
            <div id="banner-two">
            <h1>A smart way <br /> 
                     to save items</h1>
                     <p>Stack-Board uses colorful labels <br /> to organize your saved items</p>
                <div id="get-started" onClick={()=>signIn()}>
                    Get Started
                    </div>     
            </div>

                <img src={bn}  alt="banner" id="banner-img"/>
            </div>

                <div id="boxes-wrapper">
                    <div id="box1">
                        <img src={sync} alt="banner" id="sync-img"/>
                    </div>
                    <div id="box2">
                        <h1>Any time, Any where</h1>
                        <p>Sync your labels and items  <br />
                         across multiple devices without <br />
                         loosing any bit of it</p>
                    </div>
                </div>

                <div id="boxes-wrapper">
                    <div id="box2">
                        <h1>Connect with other people <br /> and share ideas</h1>
                        <p>Stack-Board items can  be shared with others<br />
                    </p>
                    </div>
                    <div id="box1">
                        <img src={share} alt="banner" id="sync-img"/>
                    </div>
                </div>

                <footer id="footer" mailto="macowigo@gmail.com">
                    <p>stack-board | from MACOWIGO</p>
                </footer>
        </div>
    )
}

export default Landing
